import React from 'react'


type Data = {
  className?: string
  onClick?: (event: React.MouseEvent) => void
  fill?: string,
  width?: number,
  height?: number,
  zIndex?: number
}


export default function IconClear({
  fill: fillProp = '#000000',
  width: widthProp = 24,
  height: heightProp = 24,
  ...props
}: Data) {

  const className = 'icon-clear' + (props.className ? ` ${props.className}` : '')

  const handleOnClick = (event: React.MouseEvent) => {
    if (!props.onClick) return
    props.onClick(event)
  }

  return (
    <svg
      style={{
        width: `${widthProp}px`,
        height: `${heightProp}px`,
        zIndex: props.zIndex
      }}
      className={className}
      onClick={handleOnClick}
      width={widthProp}
      height={heightProp}
      viewBox="0 0 24 24"
      fill={fillProp}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1 L23 23" stroke={fillProp} strokeWidth="2" strokeLinecap="round"/>
      <path d="M1 23 L23 1" stroke={fillProp} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  )
}
